import React from 'react';
import { Container, Card, Col, Row } from 'react-bootstrap';

const Portfolio = () => {
    const clients = [
        
        {
            name: 'Swan-Point.com',
            url: 'https://www.swan-point.com',
            image: '/images/portfolio/swanpoint.png',
            description: 'WordPress site for a custom boat builder featuring model specs and inquiry options.'
        },
        {
            name: 'HometownHall.com',
            url: 'https://www.hometownhall.com',
            image: '/images/portfolio/hometownhall.png',
            description: 'Custom event venue site with space details and gallery.'
        },
        {
            name: 'HotTamaleOfWashington.com',
            url: 'https://www.hottamaleofwashington.com',
            image: '/images/portfolio/hottamale.png',
            description: 'Custom restaurant site with menus, photo gallery, and brand visuals.'
        },
        {
            name: 'JenniferSaviano.net',
            url: 'https://www.jennifersaviano.net',
            image: '/images/portfolio/jennifersaviano.png',
            description: 'Custom Wix website for author showcasing book series and upcoming releases.'
        },
        {
            name: 'Campaigns.fhmc.io',
            url: 'https://campaigns.fhmc.io',
            image: '/images/portfolio/campaigns.png',
            description: 'WordPress Specialty site under FHMC offering digital tools for political campaigns.'
        }
    ];

    return (
        <Container>
            <h1 className="mt-4 mb-4">Our Portfolio</h1>
            <Row className="g-4">
                {clients.map((client, index) => (
                    <Col key={index} md={6} lg={4}>
                        <a
                            href={client.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none', color: 'inherit' }}
                        >
                            <Card className="portfolio-card h-100 text-center">
                                <div style={{ overflowY: 'auto', maxHeight: '250px' }}>
                                    <Card.Img variant="top" src={client.image} alt={client.name} />
                                </div>
                                <Card.Body>
                                    <Card.Title className='pt-1 fs-4 fw-semibold'>{client.name}</Card.Title>
                                    <Card.Text>{client.description}</Card.Text>
                                </Card.Body>
                            </Card>
                        </a>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default Portfolio;
